<template>
  <div class="container-md plr-0" :key="'user_' + $route.params.id">
    <div class="container-bg p-5 c-pro-wrap">
      <h3 class="text-uppercase" v-if="create">Nieuw lid toevoegen</h3>
      <h3 class="text-uppercase" v-else>Gegevens lid</h3>
      <div class="row">
        <div
          class="col-md-4 col-sm-12"
          v-if="!hideUserAttributes.includes('profile_image')"
        >
          <img
            :src="
              image
                ? image
                : item.profile_image
                ? item.profile_image
                : '/assets/icon.jpg'
            "
            alt=""
            class="img-fluid img-thumbnail float-md-right pro-img"
            style="width: 30%"
          />
        </div>
        <div class="col-md-8 col-sm-12">
          <h5 v-if="item.display_name">{{ item.display_name }}</h5>
          <h5 v-else-if="item.firstname">
            {{ this.item.firstname + " " + this.item.lastname }}
          </h5>
          <input
            type="file"
            id="file"
            @change="readFile()"
            style="display: none"
          />
          <button
            @click="toggle()"
            class="btn btn-dark text-white mt-3 mr-2"
            v-if="edit"
          >
            Wijzig profielafbeelding
          </button>
          <button
            @click="deleteItem()"
            class="btn btn-dark text-white mt-3 mr-2"
            v-if="edit && userHasPermissions(['Ledenadministratie']) == true"
          >
            Verwijder lid
          </button>
          <a
            :href="'/profile/' + $route.params.id + '/edit'"
            class="btn btn-dark text-white mt-3 mr-2"
            v-if="canEditProfile"
            >Bewerken</a
          >
        </div>
      </div>
      <form @submit="submit($event)">
        <div class="row">
          <div class="col-12 mt-3">
            <div class="form row">
              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('salutation')"
              >
                <label for="salutation">Aanhef</label>
                <input
                  :disabled="!edit"
                  id="salutation"
                  v-model="item.salutation"
                  placeholder="Aanhef"
                  class="form-control"
                  type="text"
                />
              </div>

              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('display_name')"
              >
                <label for="display_name">Weergavenaam</label>
                <input
                  :disabled="!edit"
                  id="display_name"
                  v-model="item.display_name"
                  placeholder="Weergavenaam"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="form row">
              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('firstname')"
              >
                <label for="firstname">Voornaam</label>
                <input
                  :disabled="!edit"
                  id="firstname"
                  v-model="item.firstname"
                  placeholder="Voornaam"
                  class="form-control"
                  type="text"
                />
              </div>

              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('lastname')"
              >
                <label for="lastname">Achternaam</label>
                <input
                  :disabled="!edit"
                  id="lastname"
                  v-model="item.lastname"
                  placeholder="Achternaam"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>

            <div class="form row">
              <div
                class="form-group col-12"
                v-if="!hideUserAttributes.includes('address')"
              >
                <label for="address">Adres</label>
                <input
                  :disabled="!edit"
                  id="address"
                  v-model="item.address"
                  placeholder="Adres"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>

            <div class="form row">
              <div
                class="form-group col-md-4 col-6"
                v-if="!hideUserAttributes.includes('zipcode')"
              >
                <label for="zipcode">Postcode</label>
                <input
                  :disabled="!edit"
                  id="zipcode"
                  v-model="item.zipcode"
                  placeholder="Postcode"
                  class="form-control"
                  type="text"
                />
              </div>

              <div
                class="form-group col-md-4 col-6"
                v-if="!hideUserAttributes.includes('city')"
              >
                <label for="city">Plaats</label>
                <input
                  :disabled="!edit"
                  id="city"
                  v-model="item.city"
                  placeholder="Plaats"
                  class="form-control"
                  type="text"
                />
              </div>

              <div
                class="form-group col-md-4 col-12"
                v-if="!hideUserAttributes.includes('country')"
              >
                <label for="country">Land</label>
                <input
                  id="country"
                  v-model="item.country"
                  placeholder="Land"
                  class="form-control"
                  type="text"
                  disabled
                />
              </div>
            </div>

            <div class="form row">
              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('mobile')"
              >
                <label for="mobile">Telefoonnummer (mobiel)</label>
                <input
                  :disabled="!edit"
                  id="mobile"
                  v-model="item.mobile"
                  placeholder="Telefoonnummer (mobiel)"
                  class="form-control"
                  type="tel"
                  pattern="[0-9]{10}"
                />
              </div>

              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('phone')"
              >
                <label for="phone">Telefoonnummer</label>
                <input
                  :disabled="!edit"
                  id="phone"
                  v-model="item.phone"
                  placeholder="Telefoonnummer"
                  class="form-control"
                  type="tel"
                  pattern="[0-9]{10}"
                />
              </div>
            </div>

            <div class="form row">
              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('username')"
              >
                <label for="username">Gebruikersnaam</label>
                <input
                  disabled
                  id="username"
                  v-model="username_generator"
                  placeholder="Gebruikersnaam"
                  class="form-control"
                  type="text"
                  @keyup="username_changed = true"
                />
              </div>

              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('email')"
              >
                <label for="email">Emailadres</label>
                <input
                  :disabled="!edit"
                  id="email"
                  v-model="item.email"
                  placeholder="Emailadres"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="form row">
              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('allow_email')"
              >
                <label for="allow_email">Stuur emails</label>
                <select
                  :disabled="!edit"
                  id="allow_email"
                  v-model="item.allow_email"
                  class="form-control"
                >
                  <option value="0">Nee</option>
                  <option value="1">Ja</option>
                </select>
              </div>

              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('mollie_payments_allowed')"
              >
                <label for="mollie_payments_allowed"
                  >Automatische incasso toestaan</label
                >
                <select
                  :disabled="!edit"
                  id="mollie_payments_allowed"
                  v-model="item.mollie_payments_allowed"
                  class="form-control"
                >
                  <option value="0">Nee</option>
                  <option value="1">Ja</option>
                </select>
              </div>
            </div>

            <hr />

            <div class="form row">
              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('date_of_birth')"
              >
                <label for="date_of_birth">Geboortedatum</label>
                <input
                  :disabled="!edit"
                  id="date_of_birth"
                  v-model="item.date_of_birth"
                  placeholder="Geboortedatum"
                  class="form-control"
                  type="date"
                />
              </div>

              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('gender')"
              >
                <label for="gender">Geslacht</label>
                <select
                  class="form-control"
                  :disabled="!edit"
                  id="gender"
                  v-model="item.gender"
                  placeholder="Geslacht"
                >
                  <option value="">-- Maak een keuze --</option>
                  <option value="-1">Vrouw</option>
                  <option value="0">Anders</option>
                  <option value="1">Man</option>
                </select>
              </div>
            </div>

            <div class="form row">
              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('member_since')"
              >
                <label for="member_since">Lid sinds</label>
                <input
                  :disabled="!edit"
                  id="member_since"
                  v-model="item.member_since"
                  placeholder="Lid sinds"
                  class="form-control"
                  type="date"
                />
              </div>

              <div
                class="form-group col-md-6 col-12"
                v-if="!hideUserAttributes.includes('member_end')"
              >
                <label for="member_end">Lid tot</label>
                <input
                  :disabled="!edit"
                  id="member_end"
                  v-model="item.member_end"
                  placeholder="Lid tot"
                  class="form-control"
                  type="date"
                />
              </div>
              <div
                class="form-group col-12"
                v-if="!hideUserAttributes.includes('about_me')"
              >
                <label for="about_me">Over mij</label>
                <editor
                  :key="'about_me' + !edit"
                  :disabled="edit ? false : true"
                  v-model="item.about_me"
                  :init="{
                    height: 200,
                    menubar: false,
                    language: 'nl',
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | removeformat | help',
                  }"
                />
              </div>
              
            </div>
            <div v-if="create && createGroups">
              <div class="form row">
                <div class="form-group col-md-4 col-12">
                  <label for="member_since">Commissies/Groepen</label>
                  <select2
                    v-model="committee.committee_id"
                    :options="
                      committees.map((d) => {
                        return { id: d.id, text: d.title };
                      })
                    "
                    :settings="{ width: '100px' }"
                  >
                  </select2>
                </div>
                <div class="form-group col-md-4 col-12">
                  <label for="">Commissies Rol</label>
                  <select2
                    v-model="committee.role_id"
                    :options="
                      committeesroles.map((d) => {
                        return { id: d.id, text: d.title };
                      })
                    "
                    :settings="{ width: '100px' }"
                  >
                  </select2>
                </div>
                <div class="form-group col-md-3 col-12">
                  <label for="">Begindatum</label>
                  <input
                    type="date"
                    v-model="committee.date_start"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-1 col-1 my-auto">
                  <a @click="addCommittees()">
                    <i
                      class="fa fa-plus ml-3"
                      style="font-size: 24px; cursor: pointer"
                    ></i>
                  </a>
                </div>
              </div>
              <div v-if="selected_committees.length">
                <hr />
                <div
                  class="row"
                  v-for="(group, index) in selected_committees"
                  :key="index"
                >
                  <div class="col-md-4 col-12">
                    {{ index + 1 }}. {{ group.committee.title }}
                  </div>
                  <div class="col-md-4 col-12">{{ group.role.title }}</div>
                  <div class="col-md-3 col-12">
                    {{ group.date_start | formatDate }}
                  </div>
                  <div class="col-md-1 col-1 my-auto">
                    <a @click="removeCommittee(group.committee_id)">
                      <i class="fas fa-trash" style="cursor: pointer"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>

          <div class="col-12 mt-2">
            <div class="alert-alert-danger">
              <p style="color: red; text-align: center">{{ error }}</p>
            </div>
            <button
              type="button"
              @click="submit($event)"
              class="btn text-white btn-dark float-right"
              v-if="create"
            >
              Aanmaken
            </button>
            <button
              type="button"
              @click="submit($event)"
              class="btn text-white btn-dark float-right"
              v-else-if="edit"
            >
              Opslaan
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "profileDetail",
  data() {
    return {
      item: {
        salutation: "",
        display_name: "",
        firstname: "",
        lastname: "",
        address: "",
        zipcode: "",
        country: "NL",
        city: "",
        date_of_birth: "",
        gender: "",
        member_since: "",
        member_end: "",
        mobile: "",
        about_me: "",
        phone: "",
        email: "",
        allow_email: 1,
        mollie_payments_allowed: 0,
        username: "",
        password: "",
        repassword: "",
        committees: [],
        subscriptions: [],
      },
      loading: false,
      error: "",
      image: null,
      edit: false,
      create: false,
      committees: [],
      committeesroles: [],
      committee: { committee_id: 0, date_start: "" },
      subscriptions: [],
      selected_committees: [],
      selected_subscriptions: [],
      username_changed: false,
      createGroups: parseInt(process.env.VUE_APP_ALLOW_PROFILE_CREATE_GROUPS),
      hideUserAttributes: process.env.VUE_APP_HIDE_USER_ATTRIBUTES.split(","),
    };
  },
  filters: {
    formatDate(value) {
      return moment(new Date(value)).format("DD-MM-YYYY");
    },
  },
  computed: {
    canEditProfile() {
      if (!this.edit && this.userHasPermissions(["Ledenadministratie"]))
        return true;

      if (
        !this.edit &&
        this.$store.state.auth.user.id == this.$route.params.id &&
        process.env.VUE_APP_USER_CAN_EDIT_OWN_PROFILE == 1
      )
        return true;

      return false;
    },
    subscriptions_all() {
      return this.subscriptions.filter(
        (subscription) => subscription.discount == 0
      );
    },
    subscriptions_discount() {
      return this.subscriptions.filter(
        (subscription) => subscription.discount == 1
      );
    },
    username_generator: {
      get: function() {
        if (this.username_changed) {
          return this.item.username;
        } else {
          if (this.item.firstname.length > 0 || this.item.lastname.length) {
            let username = `${this.item.firstname}${
              this.item.lastname.length && this.item.firstname.length ? " " : ""
            }${this.item.lastname}`;
            return username.replaceAll(" ", ".").toLowerCase();
          }
          return "";
        }
      },
      set: function(username) {
        this.item.username = username;
      },
    },
  },
  methods: {
    removeCommittee(id) {
      this.selected_committees = this.selected_committees.filter(
        (d) => d.committee_id != id
      );
    },
    addCommittees() {
      if (
        this.selected_committees.find(
          (d) => d.committee_id == this.committee.committee_id
        )
      )
        return false;

      this.committee.committee = this.committees.find(
        (d) => d.id == this.committee.committee_id
      );
      this.committee.role = this.committeesroles.find(
        (d) => d.id == this.committee.role_id
      );
      this.selected_committees.push({ ...this.committee });
    },
    readFile() {
      var file = document.getElementById("file").files[0];
      var reader = new FileReader();
      var context = this;

      reader.onload = function(data) {
        console.log(data);
        context.image = data.srcElement.result;
        //context.submit();
      };
      reader.readAsDataURL(file);
    },
    toggle() {
      document.getElementById("file").click();
    },
    async submit(e) {
      if (e) {
        e.preventDefault();
      }

      if (this.loading) {
        return false;
      }
      var selected_committees = this.selected_committees.map((comt) => {
        return {
          id: comt.committee_id,
          date_start: comt.date_start,
          role_id: comt.role_id,
        };
      });
      this.loading = true;
      this.item.username = this.username_generator;
      this.item.committees = selected_committees;
      this.item.communitySubscriptions = JSON.stringify(
        this.selected_subscriptions
      );

      if (this.create) {
        this.$store
          .dispatch("post", { endpoint: "api/v1/users", details: this.item })
          .then((data) => {
            console.log(data.data.data);
            this.loading = false;
            if (this.create) {
              window.location.href = "/profile/" + data.data.data.id + "/view";
            } else {
              window.location.href = "/community/members";
            }
          })
          .catch((error) => {
            if (error.request.status == 422) {
              var response = JSON.parse(error.request.response).errors;
              for (var err in response) {
                this.error = response[err][0];
              }
            }
            console.log(error.request);
            this.loading = false;
          });
      } else {
        var payload = new FormData();
        let val;
        for (var field in this.item) {
          val =
            this.item[field] == "null" || this.item[field] == null
              ? ""
              : this.item[field];
          payload.append(field, val);
        }

        if (this.image != null) {
          payload.append("image", document.getElementById("file").files[0]);
        }

        this.$store
          .dispatch("post", {
            endpoint: "api/v1/update/users/" + this.$route.params.id,
            details: payload,
          })
          .then((data) => {
            this.loading = false;
            console.log(data.data);
            if (data.data.redirect && data.data.redirect == true) {
              window.open(data.data.link, "_blank");
            } else {
              window.location.href =
                "/profile/" + this.$route.params.id + "/view";
            }
          })
          .catch((error) => {
            //console.log(error.request.response);
            if (error.request.status == 422) {
              var response = JSON.parse(error.request.response).errors;
              for (var err in response) {
                this.error = response[err][0];
              }
            }
            //console.log(error.request);
            this.loading = false;
          });
      }
    },
    deleteItem() {
      if (!confirm("Weet u zeker dat u deze gebruiker wilt verwijderen?")) {
        return false;
      }
      this.$store
        .dispatch("delete", "api/v1/users/" + this.$route.params.id)
        .then((data) => {
          console.log(data);
          this.loading = false;
          window.location.href = "/community/members";
        })
        .catch((error) => {
          console.log(error.request);
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
          console.log(error.request);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$store
      .dispatch("get", "api/v1/committees/all/no-user/parent-id")
      .then((data) => {
        this.committees = [];
        this.committees = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store
      .dispatch("get", "api/v1/committeesrole/all")
      .then((data) => {
        this.committeesroles = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store
      .dispatch("get", "api/v1/subscriptions")
      .then((data) => {
        this.subscriptions = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    if (this.$route.params.id) {
      this.edit = this.$route.fullPath.search("edit") == -1 ? false : true;
      this.$store
        .dispatch("get", "api/v1/users/" + this.$route.params.id)
        .then((data) => {
          this.item = { ...data.data.data };
          this.item.date_of_birth = this.item.date_of_birth
            ?.split("-")
            .reverse()
            .join("-");
          this.item.member_since = this.item.member_since
            ?.split("-")
            .reverse()
            .join("-");
          this.item.member_end = this.item.member_end
            ?.split("-")
            .reverse()
            .join("-");
          this.selected_committees = this.item.committees_instances.map(
            (d) => d.id
          );
          this.selected_subscriptions = this.item.subscriptions.map(
            (d) => d.id
          );
          if (this.item.username.length > 0) {
            this.username_changed = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.create = false;
    } else {
      this.$store.dispatch("get", "/api/v1/today").then((response) => {
        let today = response.data.today;
        this.item.member_since = today;
      });

      this.edit = true;
      this.create = true;
    }
  },
};
</script>

<style>
.select2-container .select2-selection--single {
  height: 40px !important;
}
</style>
<style scoped>
ul ul {
  list-style: none;
}
</style>
